<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div class="mt-1" v-else>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">ตรวจสอบการนับสต๊อก</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col
          xs="12"
          sm="12"
          md="4"
          lg="4"
          xl="4"
          cols="12"
          class="d-flex align-center justify-end pr-4"
        >
          <v-btn small color="success" class="white--text" @click="exportToExcel">
            <v-icon left small>mdi-microsoft-excel</v-icon>
            Export Excel
          </v-btn>
        </v-col>
      </v-row>
      <div class="mt-1">
        <v-card elevation="3" class="pa-4" style="border-radius: 15px">
          <section class="d-flex justify-space-between">
            <v-row>
              <v-col v-col xs="6" sm="6" md="8" lg="8" xl="8" cols="6"></v-col>
              <v-col xs="6" sm="6" md="4" lg="4" xl="4" cols="6">
                <div class="mt-1">
                  <v-text-field
                    color="#D6BFAF"
                    class="input-radius"
                    append-icon="mdi-magnify"
                    hide-details="auto"
                    required
                    v-model="search"
                    placeholder="ค้นหา..."
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
          </section>

          <section class="pa-3">
            <v-data-table
              :headers="headers"
              :items="data_list"
              :search="search"
              :footer-props="footer_Props"
              mobile-breakpoint="0"
            >
              <template v-slot:header.icon="{ header }">
                {{ header.text }}
                <v-tooltip top class="input-radius">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="#616A6B" v-bind="attrs" v-on="on">
                      mdi-help-circle
                    </v-icon>
                  </template>
                  <div><u> Tooltips : การกรอกข้อมูล ! </u></div>
                  <div>
                    พิมพ์ “+จำนวน” เพื่อนำไปเพิ่มในคลัง ตัวอย่างการกรอกข้อมูล
                    “+2”
                  </div>
                  <div>
                    พิมพ์ “-จำนวน” เพื่อนำไปหักในคลัง ตัวอย่างการกรอกข้อมูล “-1”
                  </div>
                  <div>พิมพ์ “0” จะไม่อัพเดตคลัง ตัวอย่างการกรอกข้อมูล “0”</div>
                </v-tooltip>
              </template>

              <template v-slot:item="dataDetail">
                <tr>
                  <td>
                    <div class="font-16">
                      {{ dataDetail.item.product_code }}
                    </div>
                  </td>
                  <td>
                    <div class="font-16">
                      {{ dataDetail.item.product_name }}
                    </div>
                  </td>
                  <td>
                    <div class="font-16">{{ dataDetail.item.quantity }}</div>
                  </td>
                  <td>
                    <div class="font-16">{{ dataDetail.item.unit_name }}</div>
                  </td>
                  <td class="text-center">
                    <div class="font-16">
                      {{ dataDetail.item.quantity_count }}
                    </div>
                  </td>
                  <td class="text-center">
                    <div
                      v-if="dataDetail.item.before_change > -1"
                      class="font-16 color-green"
                    >
                      {{ dataDetail.item.before_change }}
                    </div>
                    <div v-else class="font-16 color-red">
                      {{ dataDetail.item.before_change }}
                    </div>
                  </td>
                  <td>
                    <div class="py-3">
                      <v-text-field
                        color="#D6BFAF"
                        class="input-radius"
                        hide-details="auto"
                        v-model="dataDetail.item.after_change"
                        @keypress="isNumber($event, banking_number)"
                        @paste="isPaste($event)"
                        placeholder="อัพเดตสต๊อก"
                        single-line
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-row>
              <v-col
                xs="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
                cols="12"
                class="text-center"
              >
                <div class="title_page block-in ma-3">
                  <v-btn
                    type="button"
                    class="btn_add_data"
                    elevation="2"
                    @click="saveData()"
                    large
                    >ปรับสต๊อก</v-btn
                  >
                </div>
              </v-col>
            </v-row>
          </section>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP_ARIN } from "@/axios_arin";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { formatPrice } from "@/js/handler";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Stock_check",
  data() {
    return {
      loading_page: false,
      page_number: 1,
      search: "",
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        "items-per-page-text": "รายการต่อหน้า",
      },
      headers: [
        {
          text: "รหัสสินค้า",
          value: "product_code",
          fixed: true,
          width: "80px",
        },
        {
          text: "ชื่อสินค้า",
          value: "product_name",
          fixed: true,
          width: "250px",
        },
        {
          text: "จำนวนคลัง",
          value: "warehouse_qty",
          fixed: true,
          width: "100px",
        },
        {
          text: "หน่วย",
          value: "unit",
          fixed: true,
          width: "100px",
        },
        {
          text: "นับได้",
          value: "count",
          fixed: true,
          width: "80px",
        },
        {
          text: "ส่วนต่างก่อนปรับ ",
          value: "before_diff_count",
          fixed: true,
          width: "120px",
        },
        {
          text: "ส่วนต่างหลังปรับ",
          value: "icon",
          fixed: true,
          sortable: false,
          width: "120px",
        },
      ],
      data_list: [],
      sub_menu: [
        {
          text: "ระบบ POS",
          disabled: false,
        },
        {
          text: "คลังสินค้า",
          disabled: false,
        },
        {
          text: "นับสต๊อก",
          disabled: false,
        },
        {
          text: "ตรวจสอบการนับสต๊อก",
          disabled: false,
          href: "#",
        },
      ],
      menu_date: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateEN: "",
      // start_date: this.min_date(),
    };
  },

  methods: {
    formatPrice(number) {
      return formatPrice(number);
    },
    link(link) {
      window.location.href = link;
    },
    edit_employee() {
      this.$router.push("/arin/adminlist/editemployee");
    },
    detail_employee() {
      this.$router.push("/arin/adminlist/detailemployee");
    },

    async page(type) {
      // this.loading_page = true
      this.page_number = type;
    },
    async getCheckSotck() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      let id = this.$route.query.id;
      HTTP_ARIN.get(
        "/countstock/store/get/count/product/list/" + id,
        config
      ).then((res) => {
        if (res.data.successful === true) {
          this.data_list = res.data.message;
          this.data_list = this.data_list.map((item) => {
            const qtyCount = Number(item.quantity_count);
            const qty = Number(item.quantity);

            let after = null;
            if (qtyCount > 0) {
              const diff = qtyCount - qty;
              if (diff > 0) after = `+${diff}`;
              else if (diff < 0) after = `${diff}`;
            }

            return {
              ...item,
              after_change: after,
            };
          });
        }
      });
    },
    async saveData() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      let id = this.$route.query.id;
      this.data_list = this.data_list.map((item) => {
        return {
          ...item,
          after_change:
            item.after_change == null || item.after_change == ""
              ? 0
              : item.after_change,
        };
      });
      let data = {
        count_stock_store_id: id,
        data_list: this.data_list,
      };

      HTTP_ARIN.post("/countstock/store/update/count", data, config).then(
        (res) => {
          if (res.data.successful === true) {
            this.alert_success = true;
            let timerInterval;
            Swal.fire({
              title: "เสร็จสิ้น",
              text: "เพิ่มข้อมูลรอบนับสต๊อกเรียบร้อยแล้ว",
              icon: "success",
              timer: 2000,
              timerProgressBar: true,
              didOpen: () => {
                Swal.showLoading();
                timerInterval = setInterval(() => {}, 100);
              },
              willClose: () => {
                clearInterval(timerInterval);
              },
            }).then((result) => {
              /* Read more about handling dismissals below */
              if (result.dismiss === Swal.DismissReason.timer) {
                this.$router.push("/arin/pos/countingstocklist");
              }
            });
          }
        }
      );
    },

    exportToExcel() {
      if (!this.data_list || this.data_list.length === 0) {
        Swal.fire({
          icon: "warning",
          text: "ไม่มีข้อมูลให้ส่งออก",
          confirmButtonText: "ตกลง",
        });
        return;
      }

      // เตรียมข้อมูลสำหรับส่งออกเป็น Excel
      const rawData = this.data_list.map((item, index) => ({
        ลำดับ: index + 1,
        รหัสสินค้า: item.product_code,
        ชื่อสินค้า: item.product_name,
        จำนวนคลัง: item.quantity,
        หน่วย: item.unit_name,
        นับได้: item.quantity_count,
        ส่วนต่างก่อนปรับ: item.before_change,
        คำสั่งปรับหลังนับ: item.after_change,
      }));

      const ws = XLSX.utils.json_to_sheet(rawData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "ตรวจนับสต๊อก");

      const id = this.$route.query.id || "stock";
      const today = new Date().toISOString().slice(0, 10);
      const filename = `counting_stock_check_${id}_${today}.xlsx`;

      XLSX.writeFile(wb, filename);
    },
  },
  mounted() {
    this.getCheckSotck();
  },
};
</script>

<style scoped>
.v-timeline::before {
  top: 55px;
  height: calc(100% - 80px);
}
.theme--light.v-timeline:before {
  background-color: #d6bfaf;
  width: 4px;
}
/* .header-content {
  margin-left: -45px;
  background: #f1e9e3;
  border: 1px solid #f1e9e3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 30px 30px 0;
} */
.content-font {
  color: #616a6b;
  font-weight: 500;
  font-size: 16px;
}
.logo_timeline {
  width: 25px;
  height: 25px;
}
.logo_timeline > img {
  max-width: 25px;
}
.text_title {
  color: #616a6b;
  font-weight: bold;
  font-size: 16px;
}
.grid_half {
  display: grid;
  grid-template-columns: 45% 55%;
}
.radio_half {
  display: grid;
  grid-template-columns: 50%;
}
.v-otp-input .v-input {
  padding: 10px !important;
}
.input-radius {
  border-radius: 10px;
}
.grid_radio {
  display: flex;
  justify-content: space-between;
}
.btn_width {
  width: 50%;
}
.image_half {
  display: grid;
  grid-template-columns: 40% 60%;
}
.input_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.mobile_btn {
  width: 15%;
}
.file_input_style {
  position: absolute;
  top: -25px;
  left: 265px;
  right: 0;
  bottom: 0;
}
.preview {
  border-radius: 10px;
}
.logo_admin {
  width: 80px;
  height: 80px;
}
.logo_admin > img {
  max-width: 80px;
}
.btn_width {
  width: 50%;
}
.input-radius {
  border-radius: 10px;
}

.text_header {
  color: #616a6b;
  font-weight: bold;
  font-size: 20px;
}

.text_header_title {
  color: #616a6b;
  font-weight: bold;
  font-size: 22px;
}

/* ขนาด font 16 */
.font-16 {
  font-size: 16px !important;
}

.color-green {
  color: #88b358 !important;
}
.color-red {
  color: #ec2929 !important;
}

.text_title {
  color: #616a6b;
  font-weight: bold;
  font-size: 16px;
}

.input_two_four {
  display: grid;
  grid-template-columns: 20% 40%;
}

.input_four_six {
  display: grid;
  grid-template-columns: 40% 60%;
}

.content-header-title {
  color: #616a6b;
  font-weight: 1000;
  font-size: 20px;
  display: flex;
  align-items: center;
}

.block-in {
  display: inline-block;
}

.btn_add_data {
  font-size: 16px;
  color: #fff;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%),
    #88b358 !important;
  border-radius: 10px;
  width: 170px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
